import { render, staticRenderFns } from "./ShipperInvoices.vue?vue&type=template&id=6ce1a7f5&scoped=true"
import script from "./ShipperInvoices.vue?vue&type=script&lang=js"
export * from "./ShipperInvoices.vue?vue&type=script&lang=js"
import style0 from "./ShipperInvoices.vue?vue&type=style&index=0&id=6ce1a7f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce1a7f5",
  null
  
)

export default component.exports